var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaskList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC7FB16C-055B-42AD-A2FE-35B35CE87C82") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task-list-copy",
    transform: "translate(-165.000000, -735.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 735.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4226109,0 L2.5707113,0 C1.15094561,0 0,1.15094561 0,2.5707113 L0,21.4226109 C0,22.8423766 1.15094561,23.9933222 2.5707113,23.9933222 L21.4226109,23.9933222 C22.8423766,23.9933222 23.9933222,22.8423766 23.9933222,21.4226109 L23.9933222,2.5707113 C23.9933222,1.15094561 22.8423766,0 21.4226109,0 Z M22.2795314,21.4226109 C22.2795314,21.8958828 21.8958326,22.2795314 21.4225607,22.2795314 L2.5707113,22.2795314 C2.09743933,22.2795314 1.71379079,21.8958828 1.71379079,21.4226109 L1.71379079,2.5707113 C1.71379079,2.09743933 2.09743933,1.71379079 2.5707113,1.71379079 L21.4226109,1.71379079 C21.8958828,1.71379079 22.2795314,2.09743933 22.2795314,2.5707113 L22.2795314,21.4226109 L22.2795314,21.4226109 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71213389,5.14142259 L5.14142259,5.14142259 C4.66815063,5.14142259 4.28450209,5.52507113 4.28450209,5.9983431 C4.28450209,6.47161506 4.66815063,6.8552636 5.14142259,6.8552636 L7.71213389,6.8552636 C8.18540586,6.8552636 8.56905439,6.47161506 8.56905439,5.9983431 C8.56905439,5.52507113 8.18540586,5.14142259 7.71213389,5.14142259 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8518996,5.14142259 L11.1397657,5.14142259 C10.6664937,5.14142259 10.2828452,5.52507113 10.2828452,5.9983431 C10.2828452,6.47161506 10.6664937,6.8552636 11.1397657,6.8552636 L18.8518996,6.8552636 C19.3251715,6.8552636 19.7088201,6.47161506 19.7088201,5.9983431 C19.7088201,5.52507113 19.3251213,5.14142259 18.8518996,5.14142259 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71213389,11.1397657 L5.14142259,11.1397657 C4.66815063,11.1397657 4.28450209,11.5234142 4.28450209,11.9966862 C4.28450209,12.4699582 4.66815063,12.8535565 5.14142259,12.8535565 L7.71213389,12.8535565 C8.18540586,12.8535565 8.56905439,12.4699079 8.56905439,11.996636 C8.56905439,11.523364 8.18540586,11.1397657 7.71213389,11.1397657 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8518996,11.1397657 L11.1397657,11.1397657 C10.6664937,11.1397657 10.2828452,11.5234142 10.2828452,11.9966862 C10.2828452,12.4699582 10.6664937,12.8535565 11.1397657,12.8535565 L18.8518996,12.8535565 C19.3251715,12.8535565 19.7088201,12.4699079 19.7088201,11.996636 C19.7088201,11.523364 19.3251213,11.1397657 18.8518996,11.1397657 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71213389,17.1380586 L5.14142259,17.1380586 C4.66815063,17.1380586 4.28450209,17.5217071 4.28450209,17.9949791 C4.28450209,18.468251 4.66815063,18.8518996 5.14142259,18.8518996 L7.71213389,18.8518996 C8.18540586,18.8518996 8.56905439,18.468251 8.56905439,17.9949791 C8.56905439,17.5217071 8.18540586,17.1380586 7.71213389,17.1380586 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8518996,17.1380586 L11.1397657,17.1380586 C10.6664937,17.1380586 10.2828452,17.5217071 10.2828452,17.9949791 C10.2828452,18.468251 10.6664937,18.8518996 11.1397657,18.8518996 L18.8518996,18.8518996 C19.3251715,18.8518996 19.7088201,18.468251 19.7088201,17.9949791 C19.7088201,17.5217071 19.3251213,17.1380586 18.8518996,17.1380586 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaskList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/taskList.291b3b9dfc8a306e466e2391a3d64c3d.svg";